import { useTheme } from '@mui/material'
import {
  CircleHighlightProps,
  HighlightProps,
} from 'components/Images/Highlights/HighlightTypes'
import { handleSvgHighlightClicked } from 'components/Images/Highlights/handleSvgHighlightClicked'
import { useRef } from 'react'
import { HighlightTooltip } from './HighlightTooltip'

export const CircleHighlight = (
  props: HighlightProps<CircleHighlightProps>,
) => {
  const theme = useTheme()

  const clickStart = useRef<number | null>(null)

  return (
    <HighlightTooltip {...props}>
      <circle
        cx={props.cx}
        cy={props.cy}
        r={props.r}
        fill={theme.palette.warning.main}
        style={{
          opacity: 0.5,
          cursor: 'pointer',
        }}
        onMouseDown={() => {
          clickStart.current = performance.now()
        }}
        onMouseUp={() => {
          const clickEnd = performance.now()
          const clickDuration = clickEnd - (clickStart.current || 0)

          if (clickDuration < 100) {
            handleSvgHighlightClicked(props.id, props.pdfPage, props.pdfFeature)
          }
          clickStart.current = null
        }}
      />
    </HighlightTooltip>
  )
}
